import React from 'react';
import Box from '@mui/material/Box';
import { Tabs, Typography, IconButton, Grid, SnackbarContent, Stack } from '@mui/material';
import styles from '../../../custom/style.module.css';
import flightStyles from './flightsfolder.module.css';
import { pagelist } from 'custom/constants';
import FlightsNotesContainer from './tabs/flightnotes/FlightNotesContainer';
import {
  ArrowRight as ArrowRightIcon, ArrowLeft as ArrowLeftIcon,
  Description, Forward, NotificationsActive, Chat, 
  TextSnippet,
} from '@mui/icons-material';
import theme from 'custom/theme';
import { IconTab } from 'custom/components';
import ManifestContainer from './tabs/manifest/ManifestContainer';
import FlightInfoContainer from './info/FlightInfoContainer';
import DiscrepancyContainer from './tabs/discrepancy/DiscrepancyContainer';
import FlightReportContainer from './tabs/flightreport/FlightReportContainer';
import cookies from 'utils/cookies';
import FlightModal from './FlightModal';
import ConfirmModalContainer from '../common/confirmModal/ConfirmModalContainer';
import BuildUpContainer from './tabs/buildup/BuildUpContainer';
import ImportNotificationContainer from '../importnotification/ImportNotificationContainer';
import FlightManifestIcon from 'assets/images/flightTabIcons/manifest.png';

let filteredpagelist = pagelist.filter((page) => page?.roles.includes(cookies.get('role')));

const Flights = (props) => {

  const flightFolderTabs = [
    {
      title: 'Notes',
      icon: <Chat color='primary' />,
      iconText: 'Notes',
      pagetitle: 'My Flights | Notes',
      pageUrl: 'flight_folder/notes',
    },
    {
      title: 'Buildup',
      icon: <TextSnippet color='primary' />,
      iconText: 'Buildup',
      pagetitle: 'My Flights | Buildup',
      pageUrl: 'flight_folder/buildup',
    },
    {
      title: 'Import Notification',
      icon: <NotificationsActive color='primary' />,
      iconText: 'Import Notification',
      pagetitle: 'My Flights | Import Notification',
      pageUrl: 'flight_folder/import_notification',
    },
    {
      title: 'Manifest',
      icon: <img src={FlightManifestIcon} alt='Flight Manifest' width={30}  />,
      iconText: 'Manifest',
      pagetitle: 'My Flights | Manifest',
      pageUrl: 'flight_folder/manifest',
      iconClassName: flightStyles.manifestIcon,
    },
    {
      title: 'Discrepancies',
      icon: <Stack direction='row' className={`${flightStyles.dscpyIcon} ${flightStyles.discrepancyIcon}`}>
        <Forward color='primary' />
        <Forward color='primary' className={flightStyles.arrowLeft} />
      </Stack>,
      iconText: 'Discrepancies',
      pagetitle: 'My Flights | Discrepancies',
      pageUrl: 'flight_folder/discrepancies',
      iconClassName: flightStyles.discrepancyIcon,   
    },
    {
      title: 'Flight Report',
      icon: <Description color='primary' />,
      iconText: 'Flight Report',
      pagetitle: 'My Flights | Flight Report',
      pageUrl: 'flight_folder/flt_report',
    },
  ];
  
  const {
    value, 
    // handleUpload
  } = props;
  function TabPanel(tabPanelProps) {
    const { children, index, ...other } = tabPanelProps;
    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {tabPanelProps.value === index && (
          <Box sx={{ pt: 0 }} className={styles.positionRelative}>
            <Typography component='span'>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(path) {
    const index = path.replace('flight_folder/', '');
    return {
      id: `simple-tab-${index}`,
      value: index,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <ConfirmModalContainer />
      <FlightModal
        modal={props.modal}
        modalData={props.modalData}
        closeModal={props.closeModal}
        handleFlight={props.handleFlight}
        selected_flight={props.selected_flight}
      />
      <Box sx={{ marginLeft: 'auto' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FlightInfoContainer 
              handleSearch={props.fetchFlightData} 
              showReportModal={props.showReportModal} 
              ctype={props.ctype} 
              handleCtype={props.handleCtype}

              // history props
              id={props.flightData?.id}
              printFunction={props.printFunction}
              isNoOp={props.isNoOp}
              disableNoOp={props.disableNoOp}
              handleNoOpChange={props.handleNoOpChange}
            />
          </Grid>
          <Tabs value={value} onChange={(_, v) => props.handleChange(v)}
            indicatorColor='transparent'
            textColor='primary'
            variant='scrollable'
            scrollButtons='auto'
            aria-label='scrollable flight tabs'
            classes={{ flexContainer: flightStyles.fJcAround }}
            className={`${flightStyles.headerTab} ${flightStyles.adminTabs}`}
            ScrollButtonComponent={(props) => {
              if (
                props.direction === 'left'
              ) {
                return (
                  <IconButton aria-label='left arrow' {...props} className={flightStyles.tabArrows} disableRipple>
                    <ArrowLeftIcon
                      sx={{ color: props.disabled ? 'disabled' : theme.palette.primary.main }}
                    />
                  </IconButton>
                );
              } else if (
                props.direction === 'right'
              ) {
                return (
                  <IconButton aria-label='right arrow' {...props} className={flightStyles.tabArrows} disableRipple>
                    <ArrowRightIcon
                      sx={{ color: props.disabled ? 'disabled' : theme.palette.primary.main }}
                    />
                  </IconButton>
                );
              } else {
                return null;
              }
            }}>

            {flightFolderTabs.map((item) => {
              return filteredpagelist.find((page) => page.title === item.pagetitle) &&
                      <IconTab disableRipple={true} 
                        icon={item.icon} 
                        classes={{ 
                          root: flightStyles.flightTabRoot,
                          iconWrapper: `${flightStyles.menuIcon} ${item?.iconClassName}` 
                        }} 
                        label={item.iconText} {...a11yProps(item.pageUrl)} />;
            })}
          </Tabs>
          {
            // props.flightData && props.flightData?.reports?.find(report => report.type === props.ctype)?.status === 'Rejected' 
            props.showRejected && (
              <Grid item xs={12}>
                <SnackbarContent
                  sx={{
                    marginTop: '-24px',
                    marginBottom: props.nil ? '24px' : '0px',
                  }}
                  classes={{
                    root: styles.errorSnackbar,
                    message: styles.errorSnackbarMessage,
                  }}
                  message={(
                    <Stack direction={'column'} justifyContent={'center'}>
                      <Typography variant='body2' component='span' color='error' textAlign={'center'} fontWeight={'bold'}
                        display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
                        <span>CORRECTION REQUESTED FOR THE FLIGHT REPORT</span>
                        <Typography variant='caption' component='span' color='#000000b5'>
                          By: {props.lastRejectedLog?.user?.first_name} {props.lastRejectedLog?.user?.last_name}
                        </Typography>
                        <Typography variant='caption' component='span' color='#000000b5'> Reason: {props.rejectedReason}</Typography>
                      </Typography>
                    </Stack>
                  )}
                />
              </Grid>
            )}
          {
            props.nil && (
              <Grid item xs={12}>
                <SnackbarContent
                  sx={{ marginTop: '-24px', }}
                  classes={{
                    root: styles.warningSnackbar,
                    message: styles.warningSnackbarMessage,
                  }}
                  message={(
                    <Stack direction={'column'} justifyContent={'center'}>
                      <Typography variant='body2' component='span' color='#ff8200' textAlign='center' textTransform='uppercase' fontWeight='bold'>
                        nil manifest</Typography>
                      {/* <Typography variant='caption' component='span' color='#000000b5' textAlign='center'>
                          Some text here
                      </Typography> */}
                    </Stack>
                  )}
                />
              </Grid>
            )}
          <Grid item xs={12}>
            <TabPanel value={value} index={'notes'}>
              <FlightsNotesContainer showReportModal={props.showReportModal} ctype={props.ctype}
                showRejectedMessage={props.showRejected}
                showNilMessage={props.nil} 
                isNoOp={props.isNoOp}
              />
            </TabPanel>
            <TabPanel value={value} index={'buildup'}>
              <BuildUpContainer showReportModal={props.showReportModal} ctype={props.ctype}
                showRejectedMessage={props.showRejected}
                showNilMessage={props.nil}
                airlineLogo={props.airlineLogo}
                isNoOp={props.isNoOp}
              />
            </TabPanel>
            <TabPanel value={value} index={'import_notification'}>
              <ImportNotificationContainer flightTab={true} showReportModal={props.showReportModal}
                showRejectedMessage={props.showRejected}
                showNilMessage={props.nil}
                isNoOp={props.isNoOp}
              />
            </TabPanel>
            <TabPanel value={value} index={'manifest'}>
              <ManifestContainer fetchManifest={props.fetchManifestData} showReportModal={props.showReportModal} ctype={props.ctype} nil={props.nil}
                handleUpload={props.handleUpload} loadingManifest={props.loadingManifest} onChangeNil={props.onChangeNil}
                showRejectedMessage={props.showRejected}
                showNilMessage={props.nil}
                airlineLogo={props.airlineLogo}
                disableFlightFields={props.disableFlightFields}
                isNoOp={props.isNoOp}
              />
            </TabPanel>
            <TabPanel value={value} index={'discrepancies'} >
              <DiscrepancyContainer showReportModal={props.showReportModal} getULDData={props.getULDData} ctype={props.ctype} nil={props.nil}
                showRejectedMessage={props.showRejected}
                showNilMessage={props.nil}
                disableFlightFields={props.disableFlightFields}
                isNoOp={props.isNoOp}
              />
            </TabPanel>
            <TabPanel value={value} index={'flt_report'}>
              <FlightReportContainer showReportModal={props.showReportModal} handleOpen={props.handleOpen} ctype={props.ctype} nil={props.nil} history_data={props.history_data}
                showRejectedMessage={props.showRejected}
                showNilMessage={props.nil}
                airlineLogo={props.airlineLogo}
                updatedisableFlightFields={props.updatedisableFlightFields}
                disableFlightFields={props.disableFlightFields}
                isNoOp={props.isNoOp}
              />
            </TabPanel>
          </Grid>
        </Grid>
      </Box>

      {/* <ConfirmModalContainer /> */}
    </>
  );
};

export default Flights;
